export default __webpack_public_path__ + "static/media/pdf-svgrepo-com.afc90820.svg";